import React, { ReactNode } from "react";
import { Box, useTheme } from "@mui/material";

interface Props {
  size?: number;
  iconSize?: number;
  children?: ReactNode;
  bgColor?: string;
}

export const IconBox = ({ size = 48, iconSize, bgColor, children }: Props) => {
  const theme = useTheme();
  const finalSize = iconSize ? `${iconSize}px` : `${size * 0.55}px`;

  const commonBoxStyles = {
    width: `${size}px`,
    minWidth: `${size}px`,
    height: `${size}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const iconBoxStyles = {
    ...commonBoxStyles,
    backgroundColor: bgColor ?? theme.palette.background.neutral,
    color: theme.palette.icon.secondary,
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: "6px",
    "& svg": {
      width: finalSize,
      height: finalSize,
    },
  };

  return <Box sx={iconBoxStyles}>{children}</Box>;
};

export default IconBox;
